<template>
  <a-modal width="700px" v-model="isShow" :title="title" :afterClose="handleCancel" :maskClosable="false">
    <a-form-model
      ref="formDom"
      :model="formArticle"
      :rules="rulesArticle"
      :label-col="{ span: 5 }"
      :wrapper-col="{ span: 19 }"
    >
      <a-form-model-item :label="label" prop="loc">
        <a-input v-model.trim="formArticle.loc" placeholder="请输入" />
      </a-form-model-item>
      <a-form-model-item label="更新频率" prop="change_freq">
        <a-select v-model.trim="formArticle.change_freq" placeholder="请选择">
          <a-select-option v-for="item in labelList" :key="item.key">
            {{ item.value }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="权重" prop="priority">
        <a-input v-model.trim="formArticle.priority" placeholder="请输入" style="width: 200px" />
        <span style="color: #ccc; margin-left: 10px">此值定于0.0 - 1.0之间</span>
      </a-form-model-item>
    </a-form-model>
    <template slot="footer">
      <a-button key="back" @click="handleCancel"> 取 消 </a-button>
      <a-button key="submit" type="primary" :loading="btnloading" @click="handleSubmit"> 提 交 </a-button>
    </template>
  </a-modal>
</template>
<script>
import { reactive, toRefs, getCurrentInstance, defineComponent, onMounted, watch, computed } from '@vue/composition-api'
import { formArticle, rulesArticle } from '../business/filialeList'
import dialog from '@/composables/dialog'
import api from '@/api/'
import store from '@/store/'
const title = {
  Add: '新增',
  Edit: '编辑',
}
const label = {
  label: '标签链接',
  article: '文章链接'
}

export default defineComponent({
  mixins: [dialog],
  props: {
    platformList: {
      type: [Object, Array],
      default() {
        return {}
      },
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    params: {
      type: Object,
      default: {},
    },
  },
  setup(props, { root }) {
    const _this = getCurrentInstance()
    const state = reactive({
      label: label.label,
      rulesArticle,
      title: title.Add,
      btnloading: false,
      principalList: [], // 负责人
      formArticle: { ...formArticle },
    })
    const labelList = computed(() => {
      return store.state.label.data.WEBSITE?.WEBSITE_MAP_CHANGE_FREQ
    })
    watch(
      () => _this.params,
      async () => {
        state.formArticle = JSON.parse(JSON.stringify(_this.params))
        const responsible = state.formArticle.responsible_name + '(' + state.formArticle.responsible_number + ')'
        _this.$set(state.formArticle, 'responsible', responsible)
      }
    )

    watch(
      () => _this.isEdit,
      async () => {
        state.title = _this.isEdit ? title.Edit : title.Add
      }
    )
    onMounted(() => {
      state.label = parseInt(_this.$route.query.category) === 1 ? label.article : label.label
      state.formArticle.category = parseInt(_this.$route.query.category)
    })
    const methods = {
      handleSubmit() {
        state.btnloading = true
        _this.$refs.formDom.validate(async (valid) => {
          let res = null
          state.formArticle.website_map_id = _this.$route.query.website_map_id
          const data = { ...state.formArticle }
          if (valid) {
            if (_this.isEdit) {
              res = await api.websiteMapDetailUpdate(data)
            } else {
              res = await api.websiteMapDetailCreate(data)
            }
            if (_this.$validate(res)) {
              this.$message.success(_this.isEdit ? '编辑成功~' : '添加成功~')
              _this.isShow = false
              state.btnloading = false
              _this.$emit('handleOver')
            } else {
              state.btnloading = false
            }
          } else {
            this.$message.warning('请检查信息是否填写完成')
            state.btnloading = false
          }
        })
      },
      handleCancel() {
        _this.$refs.formDom.resetFields()
        _this.isShow = false
      },
    }
    return {
      ...toRefs(state),
      ...methods,
      labelList,
    }
  },
})
</script>
